import { REFERRAL_CODE_STORAGE_KEY } from '@/constants/tokens';
import { getQueryParamInviteCode } from '@/helpers/helpers.js';
import {
  getItemFromLocalStorage,
  removeItemFromLocalStorage,
  setItemToLocalStorage,
} from '@/helpers/localStorageServices.js';

// Persist a referral/promo code the moment it appears in the URL. Called once on app
// load (installAuth) so the code survives internal navigation — some pages strip
// ?promoCode from the URL — and is still available when the user opens registration.
export const captureReferralCodeFromUrl = () => {
  const code = getQueryParamInviteCode('promoCode');
  if (code) setItemToLocalStorage(REFERRAL_CODE_STORAGE_KEY, code);
  return code || null;
};

export const getStoredReferralCode = () =>
  getItemFromLocalStorage(REFERRAL_CODE_STORAGE_KEY) || null;

export const clearStoredReferralCode = () =>
  removeItemFromLocalStorage(REFERRAL_CODE_STORAGE_KEY);
